export default {"src":"/_next/static/media/mail-icon.e0203dda.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};